/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_status = /** @type {(inputs: {}) => string} */ () => {
	return `Stav`
};

const da_status = /** @type {(inputs: {}) => string} */ () => {
	return `Status`
};

const de_status = /** @type {(inputs: {}) => string} */ () => {
	return `Status`
};

const en_status = /** @type {(inputs: {}) => string} */ () => {
	return `Status`
};

const es_status = /** @type {(inputs: {}) => string} */ () => {
	return `Estado`
};

const fr_status = /** @type {(inputs: {}) => string} */ () => {
	return `Statut`
};

const hu_status = /** @type {(inputs: {}) => string} */ () => {
	return `Állapot`
};

const it_status = /** @type {(inputs: {}) => string} */ () => {
	return `Stato`
};

const nl_status = /** @type {(inputs: {}) => string} */ () => {
	return `Status`
};

const pl_status = /** @type {(inputs: {}) => string} */ () => {
	return `Status`
};

const pt_status = /** @type {(inputs: {}) => string} */ () => {
	return `Status`
};

const sv_status = /** @type {(inputs: {}) => string} */ () => {
	return `Status`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const status = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.status(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("status", locale)
	if (locale === "cs") return cs_status(inputs)
	if (locale === "da") return da_status(inputs)
	if (locale === "de") return de_status(inputs)
	if (locale === "en") return en_status(inputs)
	if (locale === "es") return es_status(inputs)
	if (locale === "fr") return fr_status(inputs)
	if (locale === "hu") return hu_status(inputs)
	if (locale === "it") return it_status(inputs)
	if (locale === "nl") return nl_status(inputs)
	if (locale === "pl") return pl_status(inputs)
	if (locale === "pt") return pt_status(inputs)
	return sv_status(inputs)
};